// Brand media kit (stills desde cloudfront + reels locales con logo La Romanilla)
const STILLS = "https://dheb65ihp32gm.cloudfront.net/larola/horizonte/stills";

export const still = (name) => `${STILLS}/${name}.jpg`;
// Reels servidos localmente (mismo video, con el logo nuevo Maderas La Romanilla incrustado)
export const reel = (name) => `/reels/${name}.mp4`;
// v se sube cada vez que se regenera algún poster: los navegadores cachean
// estos jpg 4h (max-age=14400) y sin el bump servirían la versión vieja.
const POSTER_V = 2;
export const poster = (name) => `/reels/posters/${name}.jpg?v=${POSTER_V}`;

// Reels de producto Best Sellers (video en R2 vía proxy API, poster local).
// IMPORTANTE: estos reels NUNCA se montan como <video> en el listado — solo
// posters <img>; el video vive únicamente dentro del lightbox (1 a la vez).
const R2_REELS = "https://api.laromanilla.com/api/products/image/maderas-la-rola/reels";
// sku enlaza el reel con su ficha de producto (precio vivo desde el API).
const productReel = (key, label, sku) => ({ key, label, sku, src: `${R2_REELS}/reel-${key}.mp4` });
export const PRODUCT_REELS = [
    productReel("gato", "Cerradura Gato", "CER361"),
    productReel("pomo", "Cerradura de Pomo Acero", "CERPOMO1"),
    productReel("duralock-381", "Cerradura Duralock 381", "CER-DURALOCK381"),
    productReel("premacol", "Premacol Secado Rápido", "PEG012"),
    productReel("pegaphil", "Pegaphil", "PEG050"),
    productReel("bisagras", "Bisagras Induma · Omega", "BIS333"),
    productReel("titebond", "Silicón Heavy Duty Titebond", "SIL-HD-TIT"),
    productReel("liquid-nails", "Silicón Wall Panel", "SIL-WALLPANEL"),
    productReel("zasc-acrilico", "Sellador Acrílico ZASC", "SEL-ACR-ZASC"),
    productReel("zasc-cocina-bano", "Silicón Negro ZASC", "SIL-NEG-ZASC"),
    productReel("zasc-transparente", "Silicón Blanco ZASC", "SIL-BLA-ZASC"),
    productReel("windows-plus", "Windows Plus · Cano", "SEL-VENT-CANO"),
    productReel("barniz-marino", "Barniz Uretanizado Quimidal", "BAR-URE-QUI"),
    productReel("duralac", "Sellador Concentrado 1/4", "SEL-CONC-14"),
    productReel("duralac-clasico", "Laca Transparente 1/4", "LAC-TRA-14"),
    productReel("duralac-sellador", "Sellador Nitro Galón", "SEL-NITRO-GL"),
    productReel("maxlaac", "Fondo Blanco Poliuretano 1K", "FON-PU-1K"),
    productReel("laacril", "Laca Blanca Acrílica Galón", "LAC-BLA-GL"),
    productReel("autocryl", "Laca Acrílica 1/4 Auto-Cryl", "LAC-ACR-14"),
    productReel("pegaphil-pote", "Cola Blanca Pegaphil Galón", "COL-PHIL-GL"),
    productReel("premacol-pote", "Cola Rosada Premacol Galón", "COL-PREM-GL"),
    productReel("poliflex", "Masilla Poliflex 1/4", "MAS-POLIFLEX"),
    productReel("contacto-plus", "Pega Pegaplus Galón", "PEG-PLUS-GL"),
    productReel("jm-5000", "Pega 5000 Contact Cement", "PEG-5000-GL"),
    productReel("contact-cement", "Pegalón Fix Cano", "PEG-FIX-CANO"),
    productReel("puerta-lisa", "Puerta Entamborada Okume", "PUE-LISA"),
    productReel("puerta-v", "Puerta Semimaciza Diseño V", "PUE-SEMI-V"),
    productReel("puerta-ruteada", "Puerta Modelo Sofía", "PUE-RUTEADA"),
    productReel("puerta-nogal", "Puerta Entamborada Cedrillo", "PUE-NOGAL"),
    productReel("kit-led", "Sensor Touch LED 12V", "KIT-LED-CON"),
    productReel("cinta-led-cob", "Cinta LED 12V · 5 m", "LED-COB-6500K"),
    productReel("fuente-led", "Transformador LED 12V 60W", "FTE-LED-60W"),
    productReel("tinte-madera", "Tinte Concentrado Madera 1L", "TIN-NEG-14"),
    productReel("jm-9000", "Pega Contacto JM 9000", "PEG-9000-GL"),
    productReel("durano-2k", "Durano Poliuretano 2K", "DUR-2K-KIT"),
    productReel("thinner-pc25", "Thinner PC-25 Galón", "THI-PC25-GL"),
    productReel("thinner-acrilico", "Thinner Acrílico Galón", "THI-ACR-GL"),
    productReel("mdf-crudo", "MDF Crudo · Tableros", "MDF-CRUDO"),
    productReel("mdf-hr", "MDF HR 15 y 18 mm", "MDF-HR"),
    productReel("melamina-blanca", "Melamina Blanca", "MEL-BLANCA"),
    productReel("chapilla", "Chapilla Natural", "CHAPILLA"),
    productReel("masonite", "Masonite / HDF", "MASONITE"),
    productReel("aglomerado-rh", "Aglomerado RH", "AGL-RH"),
    productReel("puerta-rombo", "Puerta Diseño Rombo", "PUE-ROMBO"),
    productReel("listones", "Listones Aserrados", "LISTONES"),
    productReel("laminas-dabet", "Decorativas D-ABET", "LAM-DABET"),
    productReel("alto-brillo", "Lámina Alto Brillo", "LAM-BRILLO"),
    productReel("pvc-foam", "PVC Foam Lamideco", "PVC-FOAM"),
    productReel("condimentero", "Condimentero Extraíble 20cm", "CONDIMENTERO"),
    productReel("muelle-pernio", "Muelle Pernio Justor", "MUELLE-JUSTOR"),
    productReel("cerradura-784", "Cerradura Gato 784/785", "CER-784"),
    productReel("clavos-brad", "Clavos Brad FGM F20", "CLAVOS-F20"),
    productReel("cerradura-1550", "Cerradura de Presión 1550", "CER-1550"),
    productReel("organizador-2n", "Organizador Extraíble 2 Niveles", "ORG-EXTRAIBLE"),
];

// Marketing groupings used for the reels/gallery section
export const REEL_GROUPS = [
    { key: "taller", label: "Taller y abrasivos" },
    { key: "obra", label: "Herramienta eléctrica" },
    { key: "cocina", label: "Cocina y grifería" },
    { key: "bano", label: "Baño y plomería" },
    { key: "iluminacion", label: "Iluminación LED" },
    { key: "electrico", label: "Material eléctrico" },
    { key: "seguridad", label: "Cerraduras y candados" },
    // "pintura" retirado: el video traia la marca de agua de un tercero en todos
    // sus fotogramas. El still de portada de esas categorias si esta limpio.
    { key: "fijacion", label: "Tornillería y fijación" },
    { key: "hogar", label: "Organización del hogar" },
    { key: "closet", label: "Herrajes de mueble" },
    { key: "jardin", label: "Equipos y motores" },
    { key: "mostrador", label: "Herramienta manual" },
];

export const STILL_GROUPS = {
    madera: ["deposito", "pino", "entrega", "eligiendo"],
};

// Map each DB category (37) to a real cover still keyword
export const CATEGORY_STILL = {
    "Madera de Pino Nacional": "pino",
    "Mechas y discos": "taller",
    "Seguridad (cerraduras y candados)": "seguridad",
    "Tiradores y perfiles": "closet",
    "Varios": "mostrador",
    "Bisagras": "closet",
    "Engrapadoras y grapas": "fijacion",
    "Pasadores y trancadores": "seguridad",
    "Herrajes cocina y muebles": "cocina",
    "Pie de amigo": "closet",
    "Eléctricos": "electrico",
    "Lijas": "taller",
    "Rieles y garruchas": "closet",
    "Correderas telescópicas": "closet",
    "Tornillos": "fijacion",
    "Cable eléctrico": "electrico",
    "Línea hogar Alfa": "hogar",
    "Iluminación Sylvania": "iluminacion",
    "Alcayatas": "fijacion",
    "Correderas para gavetas": "closet",
    "Quimicos": "pintura",
    "Tapatornillos y cantos": "closet",
    "Plomería Aquafina": "bano",
    "Soportes y tubos": "closet",
    "Patas": "closet",
    "Grupo F.P": "mostrador",
    "Soportes Para Entrepaños Y Separadores Para Vidrio": "closet",
    "Ganchos": "hogar",
    "Ramplugs": "fijacion",
    "Hojas caladoras": "obra",
    "Clavos y corrugaciones": "fijacion",
    "Sprays y pinturas": "pintura",
    "Línea SQ": "mostrador",
    "Ángulos y platinas": "fijacion",
    "Grupo Bm": "mostrador",
    "Herramientas eléctricas": "obra",
    "Remaches": "fijacion",
    "Griferia Grupo Ideace": "cocina",
};

export const categoryCover = (nombre) => still(CATEGORY_STILL[nombre] || "mostrador");

// Parse pine board dimensions from SKU (PINO-{ancho}X{largoCode})
const LARGO_MAP = { "12": 1.2, "244": 2.44, "366": 3.66 };
export const parsePino = (sku = "") => {
    const m = sku.match(/PINO-(\d+)X(\d+)/i);
    if (!m) return null;
    const ancho = parseInt(m[1], 10); // cm
    const largo = LARGO_MAP[m[2]] || 0; // m
    const area = (ancho / 100) * largo; // m2
    return { ancho, largo, area };
};
